module.exports = __webpack_public_path__ + "img/home.ba9d67e3.svg";